import { jsx } from "react/jsx-runtime";
import { createContext, useContext } from "react";
const initialRouter = typeof window !== "undefined" ? {
  origin: window.location.origin,
  hash: window.location.hash,
  search: window.location.search,
  pathname: window.location.pathname,
  redirect: (url) => url ? window.location.href = url : "",
  push: (url) => url ? window.history.pushState(null, window.document.title, url) : ""
} : {
  hash: "",
  origin: "",
  search: "",
  pathname: "/",
  redirect: () => {
  },
  push: () => {
  }
};
const RouterContext = createContext(initialRouter);
const RouterProvider = ({ value, children }) => {
  return /* @__PURE__ */ jsx(RouterContext.Provider, { value, children });
};
const useRouter = () => {
  const context = useContext(RouterContext);
  if (context === void 0)
    throw new Error("`useRouter` must be used within `RouterProvider`");
  return context;
};
export {
  RouterContext,
  RouterProvider,
  RouterProvider as default,
  useRouter
};
